import Typography from '../../Atoms/Typography'
import Area from '../../Molecules/Area'
import styles from './productDebugInfo.module.scss'

import React from 'react'

const ProductDebugInfo = ({ product }) => {
  const extractCategoryAndPartType = (segmentCategorization) => {
    if (!segmentCategorization) return { category: '', partType: '' }

    const segments = segmentCategorization.split(' > ')
    const category = segments[0] || ''
    const partType = segments[segments.length - 1] || ''

    return { category, partType }
  }

  const { category, partType } = extractCategoryAndPartType(product.segmentCategorization)

  return (
    <Area className={styles.area} title="Product Debug Info" brand="secondary">
      <Typography size={0.75}>
        <strong>Category:</strong> {category}
      </Typography>
      <Typography size={0.75}>
        <strong>Part Type:</strong> {partType}
      </Typography>
    </Area>
  )
}

export default ProductDebugInfo
